//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'
import moment from 'moment'

export default {
  props: {
    startTime: {
      default: undefined
    },
    endTime: {
      default: undefined
    },
    value: {
      default: () => ([])
    }
  },
  data: function () {
    // let value = ['','']
    // if (this.startTime) {
    //   value[0] = this.startTime
    // }
    // if (this.endTime) {
    //   value[1] = this.endTime
    // }
    // ['', '']
    // console.log('startTime', this.startTime)
    // console.log('endTime', this.endTime)
    let _this = this
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
            _this.$emit('update:startTime', moment(start).format('YYYY-MM-DD'))
            _this.$emit('update:endTime', moment(end).format('YYYY-MM-DD'))
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
            _this.$emit('update:startTime', moment(start).format('YYYY-MM-DD'))
            _this.$emit('update:endTime', moment(end).format('YYYY-MM-DD'))
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
            _this.$emit('update:startTime', moment(start).format('YYYY-MM-DD'))
            _this.$emit('update:endTime', moment(end).format('YYYY-MM-DD'))
          }
        }],
        onPick ({maxDate, minDate}) {
          console.log('minDate', minDate)
          console.log('maxDate', maxDate)
          if (minDate) {
            minDate = moment(minDate).format('YYYY-MM-DD')
            if (minDate !== this.startTime) {
              _this.$emit('update:startTime', minDate)
            }
          }
          if (maxDate) {
            maxDate = moment(maxDate).format('YYYY-MM-DD')
            if (maxDate !== this.endTime) {
              _this.$emit('update:endTime', maxDate)
            }
          }
          // console.log('onPick', true)
          // console.log('maxDate', maxDate)
          // console.log('minDate', minDate)
          let value = [minDate, maxDate]
          // console.log('value', value)
          _this.$emit('input', value)
        }
      },
      currentValue: this.value
    }
  },
  watch: {
    startTime: {
      handler (val) {
        // console.log('val', val)
        let s
        if (this.currentValue[0]) {
          s = moment(this.currentValue[0]).format('YYYY-MM-DD')
        }
        // console.log('s', s)
        // console.log('currentValue', this.currentValue)
        if (val && val !== s) {
          Vue.set(this.currentValue, 0,  moment(val).toDate())
        }
      },
      immediate: true
    },
    endTime: {
      handler (val) {
        // console.log('endTime', val)
        let s
        if (this.currentValue[1]) {
          s = moment(this.currentValue[1]).format('YYYY-MM-DD')
        }
        if (val && val !== s) {
          Vue.set(this.currentValue, 1,  moment(val).toDate())
        }
      },
      immediate: true
    },
    value: {
      handler (val) {
        // console.log('val', val)
        // if (val) {
        //   this.currentValue = val
        // }
      }
    }
  },
  mounted () {

  },
  methods: {

  }
}
